module.exports = __webpack_public_path__ + "static/media/vitamin_bottle_logo.9c6c16f4.png";